module.exports = __webpack_public_path__ + "assets/icon-portablePosts-nettingPortable.88260d35.svg";